module.exports = __webpack_public_path__ + "img/金玉坤.df2a9b3e.jpg";